<template>
  <div class="progressIcon__container"
       :class="background[status]"
       :style="sizeRelatedStyle[size]">
    <font-awesome-icon v-if="status === TOPIC_STATUS.COMPLETED || status === TOPIC_STATUS.MASTERED"
                       :icon="statusIcons[status]"
                       :size="size"></font-awesome-icon>
  </div>
</template>
<script>

import { TOPIC_STATUS } from "~/Components/constants";

export default {
  name: "ProgressIcon",
  components: {

  },
  props: {
    status: {
      type: String,
      default: TOPIC_STATUS.NOT_STARTED,
    },
    size: {
      type: String,
      default: "1x",
    },
    containerSize: {
      type: Number,
      default: undefined,
    },
  },
  data: () => ( {
    TOPIC_STATUS,
    background: {
      [TOPIC_STATUS.NOT_STARTED]: "progressIcon__container--not-started",
      [TOPIC_STATUS.STARTED]: "progressIcon__container--started",
      [TOPIC_STATUS.COMPLETED]: "progressIcon__container--completed",
      [TOPIC_STATUS.MASTERED]: "progressIcon__container--mastered",
    },
    statusIcons: {
      [TOPIC_STATUS.NOT_STARTED]: [],
      [TOPIC_STATUS.STARTED]: [],
      [TOPIC_STATUS.COMPLETED]: ["fas", "check"],
      [TOPIC_STATUS.MASTERED]: ["fas", "award"],
    },
    sizeRelatedStyle: {
      xs: {
        width: "16px",
        height: "16px",
      },
      sm: {
        width: "20px",
        height: "20px",
      },
      md: {
        width: "24px",
        height: "24px",
      },
      "1x": {
        width: "24px",
        height: "24px",
      },
      lg: {
        width: "32px",
        height: "32px",
      },
      "2x": {
        width: "32px",
        height: "32px",
      },
      xl: {
        width: "32px",
        height: "32px",
      },
      "3x": {
        width: "32px",
        height: "32px",
      },
    },
  } ),
};
</script>

<style lang="less" scoped>
  @import "../../Styles/utils/index.less";

  .progressIcon {

    &{}

    &__container {
      .border-radius( 50% );
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 2px;

      &{}

      &--not-started {
        background: @not-started;
      }
      &--started {
        background: @started;
      }
      &--completed {
        background: @completed;
      }
      &--mastered {
        background: @mastered;
      }
    }
  }
</style>
